module.exports = __webpack_public_path__ + "media/images/icon-dental-ccd39b9eeb2594abf12008f2b3a4ba2b.png";